//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            properties: [],
            user: {
                first_name: '',
                last_name: '',
                email: '',
                email_confirm: '',
                role: '',
                selectedProperties: []
            },
            roles: [],
            errors: ''
        };
    },

    computed: {
        parseRoles: function parseRoles() {
            var output = [],
                self = this;

            this.roles.forEach(function (r, index) {
                output.push({
                    label: self.unslugify(r.name),
                    value: r.name
                });
            });

            return output;
        }
    },
    methods: {
        refreshData: function refreshData() {
            var $el = this;

            axios.get('/prototype/properties/quick/lookup').then(function (response) {
                if (response.data) {

                    $el.properties = response.data.properties;
                }
            });
        },
        getUsersAndRoles: function getUsersAndRoles() {

            var self = this;

            window.axios.get('/prototype/user-api/all').then(function (response) {
                self.users = response.data.users;
                self.roles = response.data.roles;
            });
        },
        unslugify: function unslugify(text) {

            if (!text) return 'No Role Assigned';

            var t = text.replace('-', ' ').split(' ').map(function (s) {
                return s.charAt(0).toUpperCase() + s.substring(1);
            }).join(' ');

            return t;
        },
        closeModal: function closeModal() {
            this.clearUser();
            Event.$emit('close-small-modal');
        },
        create: function create() {

            var self = this;

            self.errors = '';

            var properties = [];

            this.user.selectedProperties.forEach(function (element, index) {
                properties.push(element.id);
            });

            this.user.selectedProperties = properties;

            axios.post('/prototype/user-api/add', this.user).then(function (response) {

                if (!response.data.error) {

                    self.clearUser();
                    Event.$emit('refresh-users-and-roles');
                    Event.$emit('close-small-modal');
                } else {

                    var errorsRaw = response.data.errors;

                    for (var e in errorsRaw) {

                        if (errorsRaw.hasOwnProperty(e)) {
                            self.errors += "\n" + errorsRaw[e][0];
                        }
                    }
                }
            });
        },
        clearUser: function clearUser() {
            this.user = {
                first_name: '',
                last_name: '',
                email: '',
                email_confirm: '',
                role: '',
                selectedProperties: []
            };
        }
    },
    mounted: function mounted() {
        var $el = this;

        this.refreshData();

        this.getUsersAndRoles();

        Event.$on('add-new-user', function () {
            $el.$children[0].$data.showSmallModal = true;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/users/UserAdd.vue
// module id = k2g+
// module chunks = 0 1